// Pick portal key from each brand
const portalKeys = ['qbe'];

export { portalKeys };
